const Vocabulary_campus = {
  topic: 'vocabulary',
  level: 'Intermediate',
  totalQuestions: 100,
  perQuestionScore: 1,

questions: [
  {
    type: "MCQs",
    question: "What is the synonym of \"arduous\"?",
    choices: [
      "Easy",
      "Difficult",
      "Joyous",
      "Simple"
    ],
    correctAnswer: "Difficult"
  },
  {
    type: "MCQs",
    question: "What is the antonym of \"benevolent\"?",
    choices: [
      "Kind",
      "Malevolent",
      "Generous",
      "Caring"
    ],
    correctAnswer: "Malevolent"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The scientist was able to ______ the problem with great precision.",
    choices: [
      "Elucidate",
      "Obfuscate",
      "Complicate",
      "Conceal"
    ],
    correctAnswer: "Elucidate"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: She don't have enough time to finish the project.",
    choices: [
      "She doesn’t have enough time to finish the project.",
      "She didn't have enough time to finish the project.",
      "She doesn't had enough time to finish the project.",
      "She not have enough time to finish the project."
    ],
    correctAnswer: "She doesn’t have enough time to finish the project."
  },
  {
    type: "MCQs",
    question: "What is a synonym for \"taciturn\"?",
    choices: [
      "Talkative",
      "Reserved",
      "Gregarious",
      "Outgoing"
    ],
    correctAnswer: "Reserved"
  },
  {
    type: "MCQs",
    question: "What is the antonym of \"meticulous\"?",
    choices: [
      "Careful",
      "Diligent",
      "Negligent",
      "Conscientious"
    ],
    correctAnswer: "Negligent"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: His arguments were so ______ that they left no room for doubt.",
    choices: [
      "Ineffectual",
      "Persuasive",
      "Obscure",
      "Vague"
    ],
    correctAnswer: "Persuasive"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: The team have completed their project ahead of schedule.",
    choices: [
      "The team has completed their project ahead of schedule.",
      "The teams have completed their project ahead of schedule.",
      "The team have completes their project ahead of schedule.",
      "The team having completed their project ahead of schedule."
    ],
    correctAnswer: "The team has completed their project ahead of schedule."
  },
  {
    type: "MCQs",
    question: "Which word is a synonym for \"candid\"?",
    choices: [
      "Deceitful",
      "Honest",
      "Secretive",
      "Evasive"
    ],
    correctAnswer: "Honest"
  },
  {
    type: "MCQs",
    question: "Choose the antonym of \"facilitate\".",
    choices: [
      "Aid",
      "Hinder",
      "Assist",
      "Propel"
    ],
    correctAnswer: "Hinder"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The proposal was so ______ that the committee approved it immediately.",
    choices: [
      "Viable",
      "Flawed",
      "Incomplete",
      "Ineffective"
    ],
    correctAnswer: "Viable"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: Everyone have their own opinion about the issue.",
    choices: [
      "Everyone has their own opinion about the issue.",
      "Everyone have their own opinions about the issues.",
      "Everyone has his own opinions about the issue.",
      "Everyone have their own opinion about issues."
    ],
    correctAnswer: "Everyone has their own opinion about the issue."
  },
  {
    type: "MCQs",
    question: "What is a synonym for \"pensive\"?",
    choices: [
      "Happy",
      "Reflective",
      "Playful",
      "Distracted"
    ],
    correctAnswer: "Reflective"
  },
  {
    type: "MCQs",
    question: "Choose the antonym of \"perpetual\".",
    choices: [
      "Everlasting",
      "Temporal",
      "Constant",
      "Endless"
    ],
    correctAnswer: "Temporal"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The artist's latest work is a ______ of modern society.",
    choices: [
      "Reflection",
      "Distortion",
      "Abomination",
      "Obfuscation"
    ],
    correctAnswer: "Reflection"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: He play the guitar beautifully.",
    choices: [
      "He played the guitar beautifully.",
      "He plays the guitar beautifully.",
      "He playing the guitar beautifully.",
      "He play the guitars beautifully."
    ],
    correctAnswer: "He plays the guitar beautifully."
  },
  {
    type: "MCQs",
    question: "Which word is a synonym for \"ubiquitous\"?",
    choices: [
      "Rare",
      "Uncommon",
      "Omnipresent",
      "Scarce"
    ],
    correctAnswer: "Omnipresent"
  },
  {
    type: "MCQs",
    question: "What is the antonym of \"lucid\"?",
    choices: [
      "Clear",
      "Obscure",
      "Easy",
      "Bright"
    ],
    correctAnswer: "Obscure"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: She spoke with such ______ that everyone was compelled to listen.",
    choices: [
      "Indifference",
      "Apathy",
      "Eloquence",
      "Confusion"
    ],
    correctAnswer: "Eloquence"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: Neither of the answers are correct.",
    choices: [
      "Neither of the answers is correct.",
      "None of the answers are correct.",
      "Neither of the answer is correct.",
      "Neither of the answers have been correct."
    ],
    correctAnswer: "Neither of the answers is correct."
  },
  {
    type: "MCQs",
    question: "A synonym for \"nefarious\" is:",
    choices: [
      "Kind",
      "Wicked",
      "Clever",
      "Sociable"
    ],
    correctAnswer: "Wicked"
  },
  {
    type: "MCQs",
    question: "Choose the antonym of \"ardent\".",
    choices: [
      "Passionate",
      "Indifferent",
      "Enthusiastic",
      "Keen"
    ],
    correctAnswer: "Indifferent"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The athlete was ______ before the big match, showcasing a courageous spirit.",
    choices: [
      "Apprehensive",
      "Anxious",
      "Intrepid",
      "Timid"
    ],
    correctAnswer: "Intrepid"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: Each of the team members were given a chance to speak.",
    choices: [
      "Each of the team members are given a chance to speak.",
      "Each of the team members has been given a chance to speak.",
      "Each of the team member were given a chance to speak.",
      "Each of the team members was given a chance to speak."
    ],
    correctAnswer: "Each of the team members was given a chance to speak."
  },
  {
    type: "MCQs",
    question: "A synonym for \"augment\" is:",
    choices: [
      "Decrease",
      "Diminish",
      "Expand",
      "Limit"
    ],
    correctAnswer: "Expand"
  },
  {
    type: "MCQs",
    question: "What is the antonym of \"abundance\"?",
    choices: [
      "Plentiful",
      "Scarcity",
      "Copiousness",
      "Wealth"
    ],
    correctAnswer: "Scarcity"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The conference aimed to ______ knowledge among participants.",
    choices: [
      "Disseminate",
      "Conceal",
      "Distract",
      "Obscure"
    ],
    correctAnswer: "Disseminate"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: There is a number of issues to discuss at the meeting.",
    choices: [
      "There is a number of issue to discuss at the meeting.",
      "There are a number of issues to discuss at the meeting.",
      "There are a number of issue to discuss at the meeting.",
      "There is a few issues to discuss at the meeting."
    ],
    correctAnswer: "There are a number of issues to discuss at the meeting."
  },
  {
    type: "MCQs",
    question: "Which word is a synonym for \"diligent\"?",
    choices: [
      "Lazy",
      "Hardworking",
      "Careless",
      "Negligent"
    ],
    correctAnswer: "Hardworking"
  },
  {
    type: "MCQs",
    question: "Choose the antonym of \"insipid\".",
    choices: [
      "Interesting",
      "Dull",
      "Flavorless",
      "Boring"
    ],
    correctAnswer: "Interesting"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: His ______ demeanor made it difficult to know what he was thinking.",
    choices: [
      "Transparent",
      "Mysterious",
      "Clear",
      "Obvious"
    ],
    correctAnswer: "Mysterious"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: The committee have reached a decision.",
    choices: [
      "The committee has reached a decision.",
      "The committees have reached a decision.",
      "The committee reaching a decision.",
      "The committee has reach a decision."
    ],
    correctAnswer: "The committee has reached a decision."
  },
  {
    type: "MCQs",
    question: "What is a synonym of \"flourish\"?",
    choices: [
      "Decline",
      "Thrive",
      "Wither",
      "Fail"
    ],
    correctAnswer: "Thrive"
  },
  {
    type: "MCQs",
    question: "What is the antonym of \"superficial\"?",
    choices: [
      "Deep",
      "Shallow",
      "Trivial",
      "Minor"
    ],
    correctAnswer: "Deep"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The treasure was ______ after years of being lost.",
    choices: [
      "Discovered",
      "Hidden",
      "Ignored",
      "Stolen"
    ],
    correctAnswer: "Discovered"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: She didn't go to the party, because she was feeling sick.",
    choices: [
      "She didn't go to the party because she was feeling sick.",
      "She doesn't go to the party, because she are feeling sick.",
      "She didn't went to the party because she was feeling sick.",
      "She didn't go to the party because she was feel sick."
    ],
    correctAnswer: "She didn't go to the party because she was feeling sick."
  },
  {
    type: "MCQs",
    question: "Which word is a synonym for \"austere\"?",
    choices: [
      "Luxurious",
      "Severe",
      "Extravagant",
      "Excessive"
    ],
    correctAnswer: "Severe"
  },
  {
    type: "MCQs",
    question: "What is the antonym of \"volatile\"?",
    choices: [
      "Stable",
      "Unpredictable",
      "Changeable",
      "Erratic"
    ],
    correctAnswer: "Stable"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: His ______ attitude made it hard for others to work with him.",
    choices: [
      "Collaborative",
      "Hostile",
      "Friendly",
      "Approachable"
    ],
    correctAnswer: "Hostile"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: If I was you, I would take the job offer.",
    choices: [
      "If I were you, I would take the job offer.",
      "If I am you, I would take the job offer.",
      "If I was you, I would taken the job offer.",
      "If I were you, I would of taken the job offer."
    ],
    correctAnswer: "If I were you, I would take the job offer."
  },
  {
    type: "MCQs",
    question: "A synonym for \"meticulous\" is:",
    choices: [
      "Careless",
      "Detailoriented",
      "Reckless",
      "Hasty"
    ],
    correctAnswer: "Detailoriented"
  },
  {
    type: "MCQs",
    question: "Choose the antonym of \"concur\".",
    choices: [
      "Agree",
      "Disagree",
      "Comply",
      "Approve"
    ],
    correctAnswer: "Disagree"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The decision to expand the company was made after careful ______.",
    choices: [
      "Thought",
      "Thinking",
      "Think",
      "Thoughtful"
    ],
    correctAnswer: "Thought"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: Each of the candidates have excellent qualifications.",
    choices: [
      "Each of the candidates has excellent qualifications.",
      "Each of the candidates have an excellent qualification.",
      "Each candidates have excellent qualifications.",
      "Both of the candidates have excellent qualifications."
    ],
    correctAnswer: "Each of the candidates has excellent qualifications."
  },
  {
    type: "MCQs",
    question: "Which word is a synonym for \"affluent\"?",
    choices: [
      "Poor",
      "Wealthy",
      "Needy",
      "Impoverished"
    ],
    correctAnswer: "Wealthy"
  },
  {
    type: "MCQs",
    question: "What is the antonym of \"indigent\"?",
    choices: [
      "Rich",
      "Needy",
      "Poor",
      "Lacking"
    ],
    correctAnswer: "Rich"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The two countries reached a ______ agreement to avoid conflict.",
    choices: [
      "Hasty",
      "Tentative",
      "Tentative",
      "Mutual"
    ],
    correctAnswer: "Mutual"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: Neither of the options seem satisfactory.",
    choices: [
      "Neither of the options seem satisfactory.",
      "None of the options seems satisfactory.",
      "Neither of the options seems satisfactory.",
      "Neither of the option seem satisfactory."
    ],
    correctAnswer: "Neither of the options seems satisfactory."
  },
  {
    type: "MCQs",
    question: "What is a synonym for \"dormant\"?",
    choices: [
      "Active",
      "Alive",
      "Inactive",
      "Lively"
    ],
    correctAnswer: "Inactive"
  },
  {
    type: "MCQs",
    question: "Choose the antonym of \"obstinate\".",
    choices: [
      "Stubborn",
      "Flexible",
      "Strongwilled",
      "Unyielding"
    ],
    correctAnswer: "Flexible"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The team worked ______ to meet the deadline.",
    choices: [
      "Reluctantly",
      "Relentlessly",
      "Halfheartedly",
      "Slowly"
    ],
    correctAnswer: "Relentlessly"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: He is better in mathematics than her.",
    choices: [
      "He is better in mathematics than she is.",
      "He is better in mathematics than her is.",
      "He is better in mathematics than hers.",
      "He is better in mathematics than she."
    ],
    correctAnswer: "He is better in mathematics than she is."
  },
  {
    type: "MCQs",
    question: "Which word is a synonym for \"reclusive\"?",
    choices: [
      "Social",
      "Withdrawn",
      "Outgoing",
      "Gregarious"
    ],
    correctAnswer: "Withdrawn"
  },
  {
    type: "MCQs",
    question: "What is the antonym of \"tranquil\"?",
    choices: [
      "Calm",
      "Agitated",
      "Peaceful",
      "Serene"
    ],
    correctAnswer: "Agitated"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The documentary aimed to ______ the issue of climate change.",
    choices: [
      "Highlight",
      "Ignore",
      "Dismiss",
      "Downplay"
    ],
    correctAnswer: "Highlight"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: The dog wagged it's tail happily.",
    choices: [
      "The dog wagged its tail happily.",
      "The dog wagged its tail happy.",
      "The dogs wagged its tail happily.",
      "The dog wagged its tails happily."
    ],
    correctAnswer: "The dog wagged its tail happily."
  },
  {
    type: "MCQs",
    question: "A synonym for \"capricious\" is:",
    choices: [
      "Stable",
      "Whimsical",
      "Predictable",
      "Consistent"
    ],
    correctAnswer: "Whimsical"
  },
  {
    type: "MCQs",
    question: "What is the antonym of \"lucid\"?",
    choices: [
      "Clear",
      "Clearheaded",
      "Comprehensible",
      "Confusing"
    ],
    correctAnswer: "Confusing"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The teacher's explanation was ______ and easy to understand.",
    choices: [
      "Ambiguous",
      "Clear",
      "Vague",
      "Complicated"
    ],
    correctAnswer: "Clear"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: He should of arrived by now.",
    choices: [
      "He should have arrived by now.",
      "He should of arrive by now.",
      "He should has arrived by now.",
      "He should arrive by now."
    ],
    correctAnswer: "He should have arrived by now."
  },
  {
    type: "MCQs",
    question: "Which word is a synonym for \"esoteric\"?",
    choices: [
      "Popular",
      "Exclusive",
      "Mainstream",
      "Universal"
    ],
    correctAnswer: "Exclusive"
  },
  {
    type: "MCQs",
    question: "What is the antonym of \"emulate\"?",
    choices: [
      "Imitate",
      "Reject",
      "Follow",
      "Copy"
    ],
    correctAnswer: "Reject"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: Her performance was so ______ that it received a standing ovation.",
    choices: [
      "Indifferent",
      "Mediocre",
      "Outstanding",
      "Average"
    ],
    correctAnswer: "Outstanding"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: They was excited about the trip.",
    choices: [
      "They were excited about the trip.",
      "They are excited about the trip.",
      "They is excited about the trip.",
      "They be excited about the trip."
    ],
    correctAnswer: "They were excited about the trip."
  },
  {
    type: "MCQs",
    question: "What is a synonym for \"verbose\"?",
    choices: [
      "Concise",
      "Wordy",
      "Brief",
      "Short"
    ],
    correctAnswer: "Wordy"
  },
  {
    type: "MCQs",
    question: "Choose the antonym of \"augment\".",
    choices: [
      "Enhance",
      "Aggrandize",
      "Reduce",
      "Increase"
    ],
    correctAnswer: "Reduce"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The ______ details of the report were difficult to comprehend.",
    choices: [
      "Simple",
      "Intricate",
      "Obvious",
      "Clear"
    ],
    correctAnswer: "Intricate"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: Me and him went to the store together.",
    choices: [
      "He and I went to the store together.",
      "Him and I went to the store together.",
      "I and he went to the store together.",
      "Me and he went to the store together."
    ],
    correctAnswer: "He and I went to the store together."
  },
  {
    type: "MCQs",
    question: "Which word is a synonym for \"quixotic\"?",
    choices: [
      "Practical",
      "Idealistic",
      "Realistic",
      "Pragmatic"
    ],
    correctAnswer: "Idealistic"
  },
  {
    type: "MCQs",
    question: "What is the antonym of \"consolidate\"?",
    choices: [
      "Combine",
      "Separate",
      "Unite",
      "Merge"
    ],
    correctAnswer: "Separate"
  },
  {
    type: "MCQs",
    question: "What is the synonym of \"incessant\"?",
    choices: [
      "Ceaseless",
      "Temporary",
      "Intermittent",
      "Occasional"
    ],
    correctAnswer: "Ceaseless"
  },
  {
    type: "MCQs",
    question: "What is the antonym of \"pristine\"?",
    choices: [
      "Clean",
      "Polluted",
      "Pure",
      "Untouched"
    ],
    correctAnswer: "Polluted"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: Despite the ______ conditions, the team managed to complete the project.",
    choices: [
      "Fortuitous",
      "Adverse",
      "Favorable",
      "Serene"
    ],
    correctAnswer: "Adverse"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: The committee have agreed on the proposal.",
    choices: [
      "The committee has agreed on the proposal.",
      "The committees have agreed on the proposal.",
      "The committee agrees on the proposal.",
      "The committee have agrees on the proposal."
    ],
    correctAnswer: "The committee has agreed on the proposal."
  },
  {
    type: "MCQs",
    question: "Which word is a synonym for \"exacerbate\"?",
    choices: [
      "Alleviate",
      "Worsen",
      "Mitigate",
      "Reduce"
    ],
    correctAnswer: "Worsen"
  },
  {
    type: "MCQs",
    question: "Choose the antonym of \"indomitable\".",
    choices: [
      "Resilient",
      "Invincible",
      "Defeated",
      "Unyielding"
    ],
    correctAnswer: "Defeated"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: Her explanation was ______, making it easier for the students to grasp the concept.",
    choices: [
      "Confusing",
      "Ambiguous",
      "Clear-cut",
      "Muddled"
    ],
    correctAnswer: "Clear-cut"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: There were a lot of people at the event.",
    choices: [
      "There was a lot of people at the event.",
      "There were many people at the event.",
      "There were a lot of person at the event.",
      "There were lots of people at the event."
    ],
    correctAnswer: "There were many people at the event."
  },
  {
    type: "MCQs",
    question: "What is a synonym for \"cursory\"?",
    choices: [
      "Thorough",
      "Hasty",
      "Careful",
      "Detailed"
    ],
    correctAnswer: "Hasty"
  },
  {
    type: "MCQs",
    question: "Choose the antonym of \"sanguine\".",
    choices: [
      "Hopeful",
      "Pessimistic",
      "Optimistic",
      "Cheerful"
    ],
    correctAnswer: "Pessimistic"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The ______ of her argument left no room for rebuttal.",
    choices: [
      "Ambiguity",
      "Clarity",
      "Confusion",
      "Obscurity"
    ],
    correctAnswer: "Clarity"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: Everybody likes their own opinion.",
    choices: [
      "Everybody likes his own opinion.",
      "Everybody likes their opinions.",
      "Everyone like their own opinion.",
      "Everybody likes one's own opinion."
    ],
    correctAnswer: "Everybody likes their opinions."
  },
  {
    type: "MCQs",
    question: "Which word is a synonym for \"lucid\"?",
    choices: [
      "Clear",
      "Confusing",
      "Ambiguous",
      "Vague"
    ],
    correctAnswer: "Clear"
  },
  {
    type: "MCQs",
    question: "What is the antonym of \"meticulous\"?",
    choices: [
      "Careful",
      "Careless",
      "Diligent",
      "Precise"
    ],
    correctAnswer: "Careless"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The athlete's ______ made him a role model for many youths.",
    choices: [
      "Indifference",
      "Tenacity",
      "Apathy",
      "Hesitance"
    ],
    correctAnswer: "Tenacity"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: She didn’t remember where she left her keys at.",
    choices: [
      "She didn’t remember where she left her keys.",
      "She didn’t remember where she left at her keys.",
      "She didn’t remember where had she left her keys.",
      "She doesn’t remember where she left her keys at."
    ],
    correctAnswer: "She didn’t remember where she left her keys."
  },
  {
    type: "MCQs",
    question: "Which word is a synonym for \"quagmire\"?",
    choices: [
      "Solution",
      "Dilemma",
      "Clarity",
      "Advantage"
    ],
    correctAnswer: "Dilemma"
  },
  {
    type: "MCQs",
    question: "Choose the antonym of \"archaic\".",
    choices: [
      "Modern",
      "Old-fashioned",
      "Outdated",
      "Ancient"
    ],
    correctAnswer: "Modern"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: His ______ was evident in the way he addressed the audience.",
    choices: [
      "Apathy",
      "Confidence",
      "Timidity",
      "Indecisiveness"
    ],
    correctAnswer: "Confidence"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: The jury were divided in their opinions about the case.",
    choices: [
      "The jury was divided in their opinions about the case.",
      "The juries have divided in their opinions about the case.",
      "The jurors were divided in their opinions about the case.",
      "The jury are divided in their opinions about the case."
    ],
    correctAnswer: "The jury was divided in their opinions about the case."
  },
  {
    type: "MCQs",
    question: "What is a synonym for \"alleviate\"?",
    choices: [
      "Intensify",
      "Relieve",
      "Soothe",
      "Aggravate"
    ],
    correctAnswer: "Relieve"
  },
  {
    type: "MCQs",
    question: "Choose the antonym of \"tenacious\".",
    choices: [
      "Determined",
      "Weak",
      "Relentless",
      "Persistent"
    ],
    correctAnswer: "Weak"
  },
  {
    type: "MCQs",
    question: "Fill in the blank: The ______ climate of the company fostered creativity among its employees.",
    choices: [
      "Conducive",
      "Discouraging",
      "Oppressive",
      "Hostile"
    ],
    correctAnswer: "Conducive"
  },
  {
    type: "MCQs",
    question: "Correct the sentence: Whoever want to play needs to sign up by tomorrow.",
    choices: [
      "Whoever wants to play need to sign up by tomorrow.",
      "Whoever want to play need to sign up by tomorrow.",
      "Whoever wants to play needs to sign up by tomorrow.",
      "Whoever want to play needs to signed up by tomorrow."
    ],
    correctAnswer: "Whoever wants to play needs to sign up by tomorrow."
  }
]
}

export default Vocabulary_campus;